import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class StudentWithdrawRequestModel {
	exit_code: string;
	exit_text: string;
	@Transform(dateTransformer)
	scheduled_withdrawal_date: Date;
	parent_confirmation?: boolean; // required for minors
	@Transform(dateTransformer)
	return_to_district_date?: Date; // mm/dd/yyyy
	district_contact?: string;
	intervention_strategy: string;
	transfer_location?: string; // required for transfer category reasons
	student_will_complete_registered_courses: boolean;
	@Transform(dateTransformer)
	completed_registered_deadline: Date;
	student_will_reenroll: string; // [yes; no; maybe]

	@Transform(dateTransformer)
	processed: Date;

	request_id: number;
	requested_by: number;
	requested_by_name: string;
	@Transform(dateTransformer)
	requested_on: Date;

	last_edited_by: number;
	last_edited_by_name: string;
	@Transform(dateTransformer)
	last_edited_on: Date;

	authorizers: {
		uid: number;
		name: string;
	}[];

	authorized_by: number;
	authorized_by_name: string;
	@Transform(dateTransformer)
	authorized_on: Date;

	approved_by: number;
	approved_by_name: string;
	@Transform(dateTransformer)
	approved_on: Date;

	rejected_by: number;
	rejected_by_name: string;
	@Transform(dateTransformer)
	rejected_on: Date;

	@Transform(dateTransformer)
	graduation_date: Date;

	reason: string;
}

export function StudentWithdrawRequestModel_ClassTransformType() {
	return StudentWithdrawRequestModel;
}

export class StudentWithdrawRequestResponseModel {
	success: boolean;
	@Type(StudentWithdrawRequestModel_ClassTransformType)
	withdraw_request: StudentWithdrawRequestModel;
}

export class StudentWithdrawRequestArgumentsModel {
	exit_code: string;
	reason: string;
	scheduled_withdrawal_date: string;
	parent_confirmation?: boolean; // required for minors
	return_to_district_date?: string; // mm/dd/yyyy
	district_contact?: string;
	intervention_strategy: string;
	transfer_location?: string; // required for transfer category reasons
	student_will_complete_registered_courses: boolean;
	completed_registered_deadline: string;
	student_will_reenroll: string; // [yes; no; maybe]
}

export class StudentGraduationWithdrawRequestArgumentsModel {
	exit_code: string;
	graduation_date?: string;
	scheduled_withdrawal_date: string;
	pause_start: number; // PHP timestamp
	notify_admins: number[];
	notes: string;
	attachments_official_transcript?: boolean;
	attachments_files?: string[];
	attachments_transcripts?: number[];
}
